// extracted by mini-css-extract-plugin
export default {"tableContainer":"styles_tableContainer__39V1H","tableRow":"styles_tableRow__D5M5a","tableRowItem":"styles_tableRowItem__r40Qt","deleteCTA":"styles_deleteCTA__utzC4"};